<template>
  <el-row>
    <el-col>
      <h2>View & Change User Notifications</h2>
      <br/>
      <el-dialog title="Add/Update Notifications for a Specific User"
        :visible.sync="addFormVisible">
        <el-row :gutter="20">
          <el-col :lg="19">
            User:<user-dropdown v-model="userId" :inputModel="userId" disabled="true"></user-dropdown>
          </el-col>
          <!--<el-col :lg="12">
            Approval No.: <el-input v-model="notificationData.id" :disabled="true"></el-input>
          </el-col>-->
        </el-row>
        <br />
        <el-row :gutter="20">
          <el-col :lg="19">
            Division: <all-division-dropdown v-model="notificationData.divisionId" :inputModel="notificationData.divisionId" :clearable="false"></all-division-dropdown>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup text="Note: The division assigned to a PEA."></tool-tip-popup>
          </el-col>
        </el-row>
        <br/>
        <el-row :gutter="20">
          <el-col :lg="19">
            Status: <all-status-dropdown v-model="notificationData.statusId" :inputModel="notificationData.statusId" :clearable="false" ></all-status-dropdown>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup text="Note: The PEA status that triggers the notification."></tool-tip-popup>
          </el-col>
        </el-row>
        <br />
        <el-row :gutter="20">
          <el-col :lg="19">
            Description: <el-input type="textarea" v-model="notificationData.peaNotificationDescription" :minlength="3" :maxlength="150" :autosize="{ minRows: 1, maxRows: 4}"></el-input>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup text="Note: The general description of the notification."></tool-tip-popup>
          </el-col>
        </el-row>
        <br />
        <el-row :gutter="20">
          <el-col :lg="12">
             Remove:  <el-checkbox v-model="notificationData.deactivate" ></el-checkbox>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup text="Note: When checked, this user notification will removed."></tool-tip-popup>
          </el-col>
        </el-row>
       <br />
        <button class="btn btn-success" @click="update()" >Update Current Notification</button>
      </el-dialog>

      <el-row>
        <el-col>
         User:<user-dropdown v-model="userId" :inputModel="userId"></user-dropdown>
          </el-col>
      </el-row>

      <br />
      <el-row>
        <el-col>
          <el-alert v-if="alertTitle !== ''"
            :title="alertTitle"
            :type="alertType"
            :description="callInfo"
            :closable="false"
            show-icon>
          </el-alert>
          <el-button class="btn btn-primary" @click="search()">Show User Notifications</el-button>
          <el-button class="btn btn-success" @click="showPopup()">Add User Notification</el-button>
        </el-col>
      </el-row>
      <el-table ref="dataTable" v-if="showTable" :data="tableData" @row-click="selectRow" v-loading="tableLoading">
        <el-table-column align="left" style="word-wrap:normal"
          prop="divisionName"
          label="PEA Division">
        </el-table-column>
        <el-table-column align="left" style="word-wrap:normal"
          prop="statusName"
          label="PEA Status">
        </el-table-column>
        <el-table-column align="left" style="word-wrap:normal"
            prop="peaNotificationDescription"
            label="Notification Description">
        </el-table-column>
      </el-table>
      <br/>
    </el-col>
  </el-row>
</template>
<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'adminViewPEANotificationsByUser',
  data () {
    return {
      isLoading: false,
      alertType: '',
      alertTitle: '',
      callInfo: '',
      tableData: [{}],
      columns: Array,
      tableLoading: true,
      showTable: false,
      addFormVisible: false,
      allowUpdate: false,
      userId: '',
      statusId: 0,
      isActive: true,
      divisionId: 0,
      notificationData: {
        id: 0,
        notificationId: '',
        divisionId: '',
        statusId: '',
        userId: 0,
        peaNotificationDescription: '',
        deactivate: false
      }
    }
  },
  methods: {
    showPopup () {
      if (this.userId === 0 || this.userId === '') {
        helperMethods.showNotification(this, 'Select a User.', 'User Required', 'error', 15000)
      } else {
        this.notificationData.statusId = null
        this.notificationData.divisionId = null
        this.notificationData.isActive = true
        this.notificationData.peaNotificationDescription = ''
        this.notificationData.id = 0
        this.notificationData.userId = this.userId
        this.approvedStatus = false
        this.addFormVisible = true
      }
    },
    selectRow: function (row) {
      if (row !== null) {
        this.notificationId = row.peaNotificationId
        var call = '/GetNotificationListenerById/' + row.id + '?peaNotificationId=' + this.notificationId
        this.$axios.get(call).then(response => {
          this.notificationData = response.data
          this.notificationId = response.data.id
          this.addFormVisible = true
        })
      }
    },
    search () {
      this.alertTitle = ''
      if (this.$store.getters.isAdmin) {
        if (this.userId === 0 || this.userId === '') {
          helperMethods.showNotification(this, 'Select a User.', 'User Required', 'error', 15000)
          this.showTable = false
          this.tableLoading = false
          this.tableData = null
          this.resultTotal = 0
        } else {
          this.showTable = true
          this.tableLoading = true
          var call = '/getNotificationListenersByUserId/' + this.userId
          this.$axios.get(call).then(response => {
            this.tableData = response.data
            this.tableLoading = false
          }).catch(reject => {
            this.tableLoading = false
            this.tableData = null
            this.resultTotal = 0
            this.showTable = false
            helperMethods.showNotification(this, 'Error Retrieving User Notifications', reject.body, 'error', 30000)
          })
        }
      }
    },
    update () {
      if (this.notificationData.userId === 0 || this.notificationData.userId === '' || this.notificationData.userId === null) {
        helperMethods.showNotification(this, 'Select a user', 'User Required', 'error', 15000)
        this.addFormVisible = true
        this.allowUpdate = false
      } else {
        if (this.notificationData.statusId === 0 || this.notificationData.statusId === '' || this.notificationData.statusId === null) {
          helperMethods.showNotification(this, 'Select a status', 'Status Required', 'error', 15000)
          this.addFormVisible = true
          this.allowUpdate = false
        } else {
          if (this.notificationData.divisionId === 0 || this.notificationData.divisionId === '' || this.notificationData.divisionId === null) {
            helperMethods.showNotification(this, 'Select a division', 'Division Required', 'error', 15000)
            this.addFormVisible = true
            this.allowUpdate = false
          } else {
            if (this.notificationData.peaNotificationDescription === '' || this.notificationData.peaNotificationDescription === null) {
              helperMethods.showNotification(this, 'Enter a description', 'Description Required', 'error', 15000)
              this.addFormVisible = true
              this.allowUpdate = false
            } else {
              this.allowUpdate = true
            }
          }
        }
      }
      if (this.allowUpdate === true) {
        this.addFormVisible = false
        var call = '/updatePEANotificationListener/' + this.notificationData.id
        return new Promise((resolve, reject) => {
          this.$axios.post(call, this.notificationData).then(response => {
            this.isLoading = false
            this.search()
            helperMethods.showNotification(this, 'Successfully Added/Updated Notification ', 'Notification Added/Updated', 'success', 10000)
          })
            .catch(reject => {
              this.isLoading = false
              helperMethods.showNotification(this, 'Error adding/updating notification', reject.body, 'error', 30000)
            })
        })
      }
    }
  }
}
</script>
